export const MAX_CAMPAIGN_TEXT_LENGTH = 1024

export const isCampaignTextWithinLimit = (value) =>
  typeof value === "string" && value.length <= MAX_CAMPAIGN_TEXT_LENGTH

